import { ServerIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export interface HostingCardProps {
  ipAddress: string
  hosting: string
  nameServerList: string[]
}

export const HostingCard: React.FC<HostingCardProps> = ({
  ipAddress,
  hosting,
  nameServerList,
}): ReactNode => (
  <Card className="hosting-info-card">
    <CardHeader className="pb-3">
      <CardTitle className="flex items-center gap-2 text-base">
        <ServerIcon className="size-4" />
        Hosting & Infrastructure
      </CardTitle>
    </CardHeader>
    <CardContent className="grid gap-3 text-sm">
      <div className="flex justify-between">
        <span className="text-muted-foreground">IP Address</span>
        <span className="font-mono font-medium">{ipAddress}</span>
      </div>
      <div className="flex justify-between">
        <span className="text-muted-foreground">Hosting Provider</span>
        <span className="font-medium">{hosting}</span>
      </div>
      <div className="flex flex-col gap-1.5">
        <span className="text-muted-foreground">Name Servers</span>
        <div className="flex flex-wrap gap-1">
          {nameServerList.map((ns) => (
            <Badge key={ns} variant="secondary" className="font-mono text-xs">
              {ns}
            </Badge>
          ))}
        </div>
      </div>
    </CardContent>
  </Card>
)
